import f from "@babel/runtime/helpers/esm/classCallCheck";
import m from "@babel/runtime/helpers/esm/createClass";
import g from "@babel/runtime/helpers/esm/assertThisInitialized";
import p from "@babel/runtime/helpers/esm/inherits";
import d from "@babel/runtime/helpers/esm/createSuper";
import l from "@babel/runtime/helpers/esm/defineProperty";
import y, { register as R, assignProps as _, Component as v } from "@semcore/core";
import n from "react";
import x from "@semcore/utils/lib/getOriginChildren";
import P from "@semcore/utils/lib/isNode";
var L = R.get("neighbor-location-context", /* @__PURE__ */ n.createContext({}));
function C(i) {
  return n.Children.toArray(i).reduce(function(r, t) {
    return /* @__PURE__ */ n.isValidElement(t) && t.type === n.Fragment ? r.push.apply(r, C(t.props.children)) : r.push(t), r;
  }, []);
}
function b(i, r) {
  var t = "both";
  if (i !== 1)
    return r === 0 && (t = "right"), r === i - 1 && (t = "left"), t;
}
var N = /* @__PURE__ */ function(i) {
  p(t, i);
  var r = d(t);
  function t() {
    var c;
    f(this, t);
    for (var a = arguments.length, e = new Array(a), o = 0; o < a; o++)
      e[o] = arguments[o];
    return c = r.call.apply(r, [this].concat(e)), l(g(c), "controlsLengthRef", /* @__PURE__ */ n.createRef()), l(g(c), "cacheChild", /* @__PURE__ */ new Map()), c;
  }
  return m(t, [{
    key: "calculateNeighborLocation",
    value: function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
      if (!this.cacheChild.has(e)) {
        var o = b(a, this.cacheChild.size);
        this.cacheChild.set(e, o);
      }
      return this.cacheChild.get(e);
    }
  }, {
    key: "getDetectProps",
    value: function() {
      return {
        getNeighborLocation: this.calculateNeighborLocation.bind(this, this.controlsLengthRef.current)
      };
    }
  }, {
    key: "setContext",
    value: function() {
      return {
        controlsLengthRef: this.controlsLengthRef
      };
    }
  }, {
    key: "render",
    value: function() {
      var a = this.asProps, e = this.asProps, o = e.Children, s = e.tag, h = e.controlsLength;
      return this.controlsLengthRef.current = h ?? C(x(o)).filter(P).length, this.cacheChild.clear(), s ? /* @__PURE__ */ n.createElement(s, _({}, a), /* @__PURE__ */ n.createElement(o, null)) : /* @__PURE__ */ n.createElement(o, null);
    }
  }]), t;
}(v);
l(N, "displayName", "NeighborLocation");
var D = /* @__PURE__ */ function(i) {
  p(t, i);
  var r = d(t);
  function t() {
    return f(this, t), r.apply(this, arguments);
  }
  return m(t, [{
    key: "render",
    value: function() {
      var a = this.asProps, e = a.children, o = a.neighborLocation, s = a.getNeighborLocation, h = s ? s(this) : void 0, u = o ?? h;
      if (e)
        return typeof e == "function" ? e(u) : /* @__PURE__ */ n.cloneElement(n.Children.only(e), {
          neighborLocation: u
        });
    }
  }]), t;
}(v);
function O(i) {
  var r = n.useContext(L), t = r.controlsLengthRef;
  return t.current === void 0 ? !1 : b(t.current, i);
}
var S = y(N, {
  Detect: D
}, {
  context: L
});
export {
  N as NeighborLocationRoot,
  S as default,
  O as useNeighborLocationDetect
};
